import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import StartCollaudo from "../views/collaudo/StartCollaudo";
import CollaudoTestDashboard from "../views/collaudo/CollaudoTestDashboard";
import CollaudoDocs from "../views/collaudo/CollaudoDocs"
import CollaudoSign from "../views/collaudo/CollaudoSign"
import CollaudoList from "../views/collaudo/CollaudoList"
import roles from "../auth/roles";

const CollaudoRouter = () => {

    let { path } = useRouteMatch();

    return (
        <Switch>
            <PrivateRoute
                key="dashboard"
                path={`${path}/dashboard`}
                exact
                component={() => <h3>Collaudo dashboard here... work in progress!</h3>}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
            <PrivateRoute
                exact
                key="addCollaudo"
                path={`${path}/start-collaudo`}
                component={StartCollaudo}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
            <PrivateRoute
                exact
                key="listCollaudi"
                path={`${path}/list`}
                component={CollaudoList}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
            <PrivateRoute
                exact
                key="collaudoTest"
                path={`${path}/test-dashboard/:collaudoId`}
                component={CollaudoTestDashboard}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
            <PrivateRoute
                exact
                key="collaudoDocs"
                path={`${path}/docs/:collaudoId`}
                component={CollaudoDocs}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
            <PrivateRoute
                exact
                key="collaudoSign"
                path={`${path}/sign/:collaudoId`}
                component={CollaudoSign}
                roles={[roles.ADMIN, roles.COLLAUDO]}
            />
        </Switch>
    );
};

export default CollaudoRouter;
